"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isComboProfitable = isComboProfitable;
// null/undefined means that the profitability is not checked, and combo is assumed to be profitable
function isComboProfitable({ isProfitable } = {}) {
    return isProfitable !== false;
}
//# sourceMappingURL=isComboProfitable.js.map